import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1a2b4330"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-missing" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "text-missing" }
const _hoisted_7 = { class: "text-missing" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_9 = ["title"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-missing" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: `/ico/support-blue.svg` }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "score-container" }
const _hoisted_18 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isPercentageShown)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.question.options as MultipleQuestionOptions).getChoices(), (choice) => {
          return (_openBlock(), _createElementBlock("tr", null, [
            (choice.text === '')
              ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.Lang.getI18N("answer-missing")), 1)
                ]))
              : (_openBlock(), _createElementBlock("td", _hoisted_3, [
                  _createElementVNode("span", null, _toDisplayString(choice.text), 1)
                ])),
            _createElementVNode("td", null, [
              _createElementVNode("span", null, _toDisplayString(`${_ctx.getAnswerPercentage(choice)}%`), 1)
            ]),
            _hoisted_4
          ]))
        }), 256)),
        (_ctx.hasEmptyQuestions)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.Lang.getI18N("answer-missing")), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(`${_ctx.getEmptyPercentage}%`), 1)
              ]),
              _hoisted_8
            ]))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.answers, (answer) => {
        return (_openBlock(), _createElementBlock("tr", {
          title: answer.getAuditorLabel(_ctx.state.stores!)
        }, [
          (answer.toPDF() === '')
            ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.Lang.getI18N("answer-missing")), 1)
              ]))
            : (_openBlock(), _createElementBlock("td", _hoisted_12, [
                _createElementVNode("span", null, _toDisplayString(answer.toPDF()), 1)
              ])),
          _hoisted_13,
          _createElementVNode("td", null, [
            (answer.comment !== null)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "comments-container",
                  onClick: ($event: any) => (_ctx.showComment(answer))
                }, _hoisted_16, 8, _hoisted_14))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("td", _hoisted_17, [
            (_ctx.question.score)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(`${answer.score}/${_ctx.question.score}`), 1))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_9))
      }), 256))
}